/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import merge from 'lodash.merge';
import { MetricDataPoint, Periods } from 'cio/utils/metrics/common';
import { getMaxOfArray } from 'cio/utils/array';
import { mapPercentDataPoints } from 'cio/utils/graphs';
import type { Options, PointOptionsObject, SeriesLineOptions, XAxisOptions } from 'highcharts';

interface HcSparkLineChartArgs {
  series: MetricDataPoint[];
  enableExport?: boolean;
  period?: Periods;
}

export default class HcSparkLineChart extends Component<HcSparkLineChartArgs> {
  get period() {
    return this.args.period ?? Periods.DAYS;
  }

  get series() {
    return this.args.series ?? [];
  }

  get maxValue() {
    return getMaxOfArray(this.series.map((p) => p.y));
  }

  get chartOptions(): Options {
    return merge(
      {},
      {
        series: [
          {
            data: mapPercentDataPoints(this.series) as PointOptionsObject[],
            colorIndex: this.maxValue === 0 ? 'gray-200' : ('purple-700' as any),
          } as SeriesLineOptions,
        ],

        chart: {
          type: 'line',
          width: 100,
          height: 22,
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingRight: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          animation: false,
          zoomType: null as any, // need to use "any" since Highcharts only
          // accepts 'x' | 'y' | 'xy' | undefined, and we already set 'x' as
          // default in utils/graphs.ts. If we use "undefined" it won't override
          // the default value, so we need to use null.
        },

        xAxis: {
          type: 'datetime',
          startOnTick: false,
          endOnTick: false,
          visible: false,
        } as XAxisOptions,

        yAxis: {
          startOnTick: false,
          endOnTick: false,
          visible: false,
          min: -0.1, // Extend y axis min to prevent 0-value lines from getting slightly cut off
        },

        plotOptions: {
          series: {
            animation: false,
            enableMouseTracking: false,
          },
          line: {
            className: 'highcharts-line-width-1',
          },
        },

        legend: {
          enabled: false,
        },

        tooltip: {
          enabled: false,
        },
      },
    );
  }
}
